import instance from "./api";
import moment from "moment";

export type Status = 'pending' | 'approved' | 'rejected' | 'promoted' | '';
type fileUploads = [{
  name: string,
  blobs: [{
    name: string,
    cdnUrl: string
  }]
}]
export type Submission = {
  index: number,
  id: number,
  firstName: string,
  lastName: string,
  status: Status,
  email: string,
  instagram: string,
  location: string,
  description: string,
  isAcceptFurtherCommunication: boolean,
  original: string,
  thumbnail: string,
  filename: string,
  fileUploads: fileUploads,
  createdAt: string,
  date_submitted: string,
  noteContent: string,
}

let pageNum = 1;
let totalPages = -1;

function getPageNum() {
    return pageNum;
}

function incrementPageNum() {
    pageNum++;
}

export function setPageNum(val: number) {
    pageNum = val;
}

function getTotalPages() {
    return totalPages;
}

function setTotalPages(val: number) {
    totalPages = val;
}

export const RetrieveSubmissions = async (status: Status) => {
  let new_rows: Submission[] = [];

  while (((getTotalPages() === -1) || (getPageNum() <= getTotalPages())) && getPageNum() !== -1) {
    let temp_rows: Submission[] = [];
    await instance.get('/admin/api/v1/submissions', { params: { perPage: 100, pageNum: getPageNum(), status } })
    .then((res) => {
      if (res.status > 299) {
        setPageNum(-1);
        throw new Error('error: ' + res.status);
      }
      else {
        return res.data;
      }
    })
    .then((data: {
        data: Array<Submission>,
        metaData: {
          totalPage: number
        }
    }) => {
      incrementPageNum();
      setTotalPages(data.metaData.totalPage);

      return data.data.map((obj, index) => {
        return {
          index: Math.floor(index + (100 * (getPageNum() - 2))),
          id: obj.id,
          firstName: obj.firstName,
          lastName: obj.lastName,
          status: obj.status,
          email: obj.email,
          instagram: obj.instagram,
          location: obj.location,
          description: obj.description,
          isAcceptFurtherCommunication: obj.isAcceptFurtherCommunication,
          original: obj.fileUploads[0].blobs.find((item) => {return item.name === 'original'})?.cdnUrl,
          thumbnail: obj.fileUploads[0].blobs.find((item) => {return item.name === 'thumbnail'})?.cdnUrl,
          filename: obj.fileUploads[0].name,
          files: obj.fileUploads,
          noteContent: obj.noteContent,
          date_submitted: moment(obj.createdAt).format('YYYY-MM-DD'),
        };
      });
    })
    .then((rows) => {
        temp_rows = temp_rows.concat(rows as any);
    })
    .catch((err) => {
      console.error(err);
      setPageNum(-1);
      return;
    })
    new_rows = new_rows.concat(temp_rows);
  }
  new_rows = new_rows.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.id === value.id
    ))
  )
  return new_rows;
}

export const updateSubmission = async(id:number, target: Status):Promise<Submission> => {
  return await instance.put('/admin/api/v1/submission-statuses/' + id, { newStatus: target })
    .then((res) => {
      if (res.status > 299) {
        setPageNum(-1);
        throw new Error('error: ' + res.status);
      }
      else {
        return res.data;
      }
    })
    .then((res: any)=> {
      return res.data;
    })
    .catch((err) => {
      return err;
    })
}